export default __webpack_public_path__ + "static/media/google-drive.8fe56280.png";